export default {
  default: () => import("/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/layouts/default.vue"),
  "map-search": () => import("/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/layouts/mapSearch.vue")
}